import { render, staticRenderFns } from "./DeliveryMethodForm.vue?vue&type=template&id=7c309654&scoped=true&"
import script from "./DeliveryMethodForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryMethodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c309654",
  null
  
)

export default component.exports